module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
  siteTitle: 'Louis Sanchez', // Navigation and Site Title
  siteTitleAlt: 'Louis Sanchez - Portfolio', // Alternative Site title for SEO
  siteUrl: 'https://lsmagic.com', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: '/logos/logo-1024.png', // Used for SEO and manifest
  siteDescription: 'Louis Sanchez - Web Developer, Designer, Artist',
  author: 'Louis Sanchez', // Author for schemaORGJSONLD
  // siteFBAppID: '123456789', // Facebook App ID - Optional
  userTwitter: '@lsmagic', // Twitter Username
  ogSiteName: 'lsmagic', // Facebook Site Name
  ogLanguage: 'en_US',
  googleAnalyticsID: 'UA-132416990-1',
  // Manifest and Progress color
  themeColor: '#42D3B6',
  backgroundColor: '#2b2e3c',
  // Settings for typography.jsx
  headerFontFamily: 'Questrial',
  bodyFontFamily: 'Questrial',
  baseFontSize: '16px'
}
